import React from 'react';
import PropTypes from 'prop-types';

import { HubPropTypes } from 'dpl/prismic/utils/customPropTypes';

import { DISPLAY_TYPE_TO_COMPONENT } from '../utils/displayTypeToComponent';
import { DISPLAY_TYPES } from '../utils/constants';

export default function ArticleGroup({ sliceData }) {
  const Component = DISPLAY_TYPE_TO_COMPONENT[sliceData.primary.display_type];
  const articles = sliceData.items
    .map(i => {
      if (i.article.data) {
        return i.article;
      }
      return null;
    })
    .filter(Boolean);

  return (
    <div className="PrismicArticleGroup container">
      <Component
        articles={articles}
        headline={sliceData.primary.headline}
        hubPage={sliceData.primary.view_all_hub}
      />
    </div>
  );
}

ArticleGroup.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      display_type: PropTypes.oneOf(Object.values(DISPLAY_TYPES)).isRequired,
      headline: PropTypes.string.isRequired,
      view_all_hub: HubPropTypes
    }).isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        // eslint-disable-next-line react/forbid-prop-types
        article: PropTypes.object.isRequired
      })
    ).isRequired
  }).isRequired
};
